import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'app/shared/services/data/data.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  loading = false;
  inactive = false;

  constructor(
    private titleService: TitleService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private dataservice: DataService,
    private router: Router,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.titleService.title.next('Mot de passe oublié');
    this.intitForm();
  }

  isInactive(inputValue: string): void {
    inputValue ? this.inactive = true : this.inactive = false;
  }

  onSubmit(): void {
    this.inactive = true;

    if (this.resetPasswordForm.invalid) {
      this.errorsToManage();
      return;
    }
    this.loading = true;

    const email = this.resetPasswordForm.get('email').value;
    this.dataservice.email.next(email);
    this.userService.sendEmailUserForResetPassword(email).subscribe(() => { });
    this.router.navigate(['/reset-password-send']);
  }

  private errorsToManage(): void {
    if (this.f.email.errors?.required) {
      this.uiService.openSnackBar('Le champs email est requis', '');
    }
    if (this.f.email.errors?.email) {
      this.uiService.openSnackBar(`L'email n'est pas valide`, '');
      this.resetPasswordForm.reset({
        email: ''
      });
      this.inactive = false;
    }
  }

  get f() {
    return this.resetPasswordForm.controls;
  }

  private intitForm(): void {
    this.resetPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

}
